import React from 'react';
import Modal from 'react-bootstrap/Modal';

type ModalState = {
    show: boolean;
}

type ModalProps = {
    linkName: any;
    caption?: any;
    locale: string;
}

export default class ModalDialog extends React.PureComponent<ModalProps, ModalState> {
    constructor(props: ModalProps) {
        super(props);

        this.state = {
            show: false
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleShow = this.handleShow.bind(this);
    }

    handleClose = () => this.setState({ show: false });
    handleShow = (event: any) => {this.setState({ show: true }); event.preventDefault(); return false;};

    render() {
        const { show } = this.state;
        const { locale } = this.props;
        const isRTL = ['ar', 'he', 'fa', 'ur'].includes(locale);

        if (isRTL) {
            return (
                <>
                    <a href="#" onClick={this.handleShow}>
                        {this.props.linkName}
                    </a>
                    <Modal
                        show={show}
                        onHide={this.handleClose}
                        size="lg"
                        dir="rtl"
                    >
                        <Modal.Header
                            closeButton
                            style={{ direction: 'rtl', textAlign: 'right' }}
                        >
                            <strong>
                                {this.props.caption || this.props.linkName}
                            </strong>
                        </Modal.Header>
                        <Modal.Body
                            style={{ direction: 'rtl', textAlign: 'right' }}
                        >
                            {this.props.children}
                        </Modal.Body>
                    </Modal>
                </>
            );
        } else {
        return (
            <>
                <a href="#" onClick={this.handleShow}>{this.props.linkName}</a>
                <Modal show={show} onHide={this.handleClose} size="lg">
                    <Modal.Header closeButton>
                        <strong>{this.props.caption || this.props.linkName}</strong>
                    </Modal.Header>
                    <Modal.Body>
                        {this.props.children}
                    </Modal.Body>
                </Modal>
            </>
        );
    }
    }
}